/** Media type of the XLSX workbooks the backend exports; requested via `Accept`. */
export const XLSX_MEDIA_TYPE =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
